export default __webpack_public_path__ + "static/media/deixa-com-a-junta.ea54df19.jpg";